import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";
import { readMagSession, writeMagSession, clearMagSession } from "./magSession";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = lädt, null = Gast
  const [magSession, setMagSessionState] = useState(() => readMagSession());

  const loginMag = useCallback((s) => {
    writeMagSession(s);
    setMagSessionState(readMagSession());
  }, []);

  const logoutMag = useCallback(() => {
    const token = sessionStorage.getItem("mag_token");
    // Sofort lokal abmelden, damit unmittelbar der Login erscheint …
    clearMagSession();
    setMagSessionState(null);
    // … die serverseitige Sitzung wird im Hintergrund beendet (blockiert den Logout nicht).
    if (token) {
      api.post("/magauth/logout", {}, { headers: { Authorization: `Bearer ${token}` } }).catch(() => {});
    }
  }, []);

  useEffect(() => {
    // OAuth-Callback: AuthCallback tauscht die session_id zuerst gegen eine Session
    if (window.location.hash?.includes("session_id=")) return;
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(null));
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  }, []);

  const testLogin = useCallback(async (role) => {
    const { data } = await api.post("/auth/test-login", { role });
    setUser(data);
    return data;
  }, []);

  const logout = useCallback(async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(null);
  }, []);

  return <AuthCtx.Provider value={{ user, setUser, login, logout, testLogin, magSession, loginMag, logoutMag }}>{children}</AuthCtx.Provider>;
}

export function useAuth() {
  return useContext(AuthCtx);
}

export function homeFor(user) {
  if (!user) return "/";
  const r = user.roles || [];
  if (r.includes("admin")) return "/admin/liegenschaften";
  if (r.includes("hausmeister")) return "/hausmeister";
  if (r.includes("management")) return "/management";
  return "/";
}
